import tw from "tailwind-styled-components";

export const ContainerLogin = tw.div`
w-full rounded-md
max-w-[95vw] sm:max-w-[80vw] md:max-w-[60vw] lg:max-w-[40vw] xl:max-w-[30vw]
min-h-[80vh] flex flex-col justify-center mx-auto
bg-transparent
transition-colors duration-300
`;

export const ComponentTitle = tw.p`
font-Outfit font-bold text-lg sm:text-xl md:text-2xl lg:text-3xl
text-center text-primary-500
max-w-[95%] sm:max-w-[90%] md:max-w-[80%] lg:max-w-[70%] mx-auto
`;

export const ComponentIcon = tw.div`
flex justify-center items-center
`;

export const ContainerForm = tw.div`
flex flex-col gap-1
my-5 md:my-6 lg:my-2 xl:my-8
px-2 sm:px-4 md:px-8 lg:px-10
`;

export const Form = tw.form`
flex flex-col gap-5
`;

export const ContainerLabelInput = tw.div`
flex flex-col gap-2
`;

export const Label = tw.label`
text-xs sm:text-sm md:text-base font-semibold text-gray-900 dark:text-gray-100
transition-colors duration-300
`;

export const ContainerInput = tw.div`
flex flex-col w-full gap-1
`;

export const Input = tw.input`
border-2 border-[#DFE5EF] dark:border-dark-border focus:outline-none
rounded-lg py-2 px-4 sm:px-5 md:px-6
text-xs sm:text-sm md:text-base
bg-white dark:bg-dark-surface text-gray-900 dark:text-white
placeholder-gray-400 dark:placeholder-gray-500
transition-colors duration-300
${(props) =>
  props.styleprop
    ? "border-red-600 focus:border-red-600"
    : "hover:border-primary-500 focus:border-primary-500"}
`;

export const ContainerInputPassword = tw.div`
border-2 border-[#DFE5EF] dark:border-dark-border focus:outline-none
flex gap-1 rounded-lg pr-4 sm:pr-5 items-center pl-4 sm:pl-5
bg-white dark:bg-dark-surface
transition-colors duration-300
${(props) =>
  props.styleprop
    ? "border-red-600 focus:border-red-600"
    : "hover:border-primary-500 focus:border-primary-500"}
`;

export const InputPassword = tw.input`
w-full focus:outline-none py-2 text-sm sm:text-base md:text-lg
bg-transparent text-gray-900 dark:text-white
placeholder-gray-400 dark:placeholder-gray-500
transition-colors duration-300
`;

export const EyeButton = tw.button`
flex items-center justify-center
`;

export const Errors = tw.p`
text-xs sm:text-sm text-center text-red-600
`;

export const ContainerButtons = tw.div`
flex flex-col gap-2 items-center px-4 sm:px-8 md:px-10 xl:mt-8
`;

export const LinkButton = tw.button`
text-xs sm:text-sm font-medium text-primary-500 mb-4
`;

export const LoginButton = tw.button`
w-full font-bold text-white
px-4 py-2 md:py-3 rounded-lg
bg-primary-500 hover:bg-primary-400
shadow-sm shadow-gray-500
text-base sm:text-lg md:text-xl
`;

export const ContainerSwitch = tw.div`
w-full flex items-center justify-center
`;

export const Switch = tw.label`
relative inline-flex items-center cursor-pointer
`;

export const Language = tw.span`
ms-3 text-xs sm:text-sm font-bold text-slate-900 dark:text-slate-100
transition-colors duration-300
`;

export const ModalOverlay = tw.div`
fixed inset-0 bg-black/50 flex items-center justify-center z-50
transition-opacity duration-300
`;

export const ModalContent = tw.div`
bg-white dark:bg-[#1E1E1E] rounded-xl shadow-2xl
w-full max-w-[90vw] sm:max-w-md p-6 sm:p-8
transition-colors duration-300
`;

export const ModalTitle = tw.h2`
text-xl sm:text-2xl font-bold text-gray-900 dark:text-white
text-center mb-2
`;

export const ModalDescription = tw.p`
text-sm sm:text-base text-gray-600 dark:text-gray-400
text-center mb-6
`;

export const ModalButtonsContainer = tw.div`
flex flex-col gap-3 mt-6
`;

export const BackButton = tw.button`
text-sm font-medium text-gray-500 dark:text-gray-400
hover:text-primary-500 transition-colors duration-200
`;
